<!--
 * @Description: 
 * @Date: 2021-02-05 00:06:29
-->
<template>
  <ul class="gift" v-show="value" @click.stop="()=>{}">
    <li
      v-for="(item, index) in gifts"
      :key="index"
      :class="['gift__item', isActive(index) ? 'gift__item--active' : '']"
      @click.stop="activeIndex = index"
    >
      <div>
        <img :src="item.img" alt />
        <p>{{ item.name }}</p>
      </div>
      <p v-show="isActive(index)" @click.stop="send(index)">{{item.handlerText}}</p>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      handlerText: '赠送',
      activeIndex: 0,
      gifts: [
        {
          name: '掌声',
          img:
            'http://cdn.yxvzb.com/WEB/SaaS/polymerization/images/living/zs.png',
          id: 1,
          handlerText: '赠送',
          timer: null
        },
        {
          name: '悬壶济世',
          img:
            'http://cdn.yxvzb.com/WEB/SaaS/polymerization/images/living/xhjs.png',
          id: 2,
          handlerText: '赠送',
          timer: null
        },
        {
          name: '百合花',
          img:
            'http://cdn.yxvzb.com/WEB/SaaS/polymerization/images/living/bhh.png',
          id: 3,
          handlerText: '赠送',
          timer: null
        },
        {
          name: '华佗在世',
          img:
            'http://cdn.yxvzb.com/WEB/SaaS/polymerization/images/living/htzs.png',
          id: 4,
          handlerText: '赠送',
          timer: null
        }
      ],
      timer: null
    };
  },
  components: {},
  watch: {
    livingStatus: {
      immediate: true,
      handler(v) {
        if (v === 2) {
          this.gifts.forEach((item, index) => {
            this.setItemInterval(index);
          });
        }
      }
    }
  },
  computed: {
    livingStatus() {
      return this.$store.state.living.livingStatus;
    }
  },
  methods: {
    isActive(index) {
      return this.activeIndex === index;
    },
    setItemInterval(index) {
      this.gifts[index].timer && clearInterval(this.gifts[index].timer);
      this.gifts[index].handlerText = 60;
      this.gifts[index].timer = setInterval(() => {
        if (this.gifts[index].handlerText <= 0) {
          clearInterval(this.gifts[index].timer);
          this.gifts[index].handlerText = '赠送';
          return;
        }
        this.gifts[index].handlerText -= 1;
      }, 1000);
    },
    send(index) {
      if (this.livingStatus !== 2) {
        this.$toast(this.livingStatus === 1 ? '直播还未开始' : '直播已结束');
        return;
      }
      if (this.gifts[index].handlerText === '赠送') {
        this.setItemInterval(index);
        this.$emit('send', this.gifts[index]);
        this.$emit('input', false);
      }
    }
  },
  beforeDestroy() {
    this.gifts.forEach((item, index) => {
      this.gifts[index].timer && clearInterval(this.gifts[index].timer);
    });
  }
};
</script>

<style scoped lang="scss">
.gift {
  background: #ededed;
  padding: 0.27rem 0.21rem 0;
  border-top-left-radius: 0.32rem;
  border-top-right-radius: 0.32rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
  &__item {
    width: 1.91rem;
    height: 2.55rem;
    padding-top: 0.16rem;
    text-align: center;
    border-radius: 0.32rem;
    div {
      margin-bottom: 0.2rem;
      img {
        width: 1rem;
        height: 1rem;
        margin-bottom: 0.16rem;
        object-fit: contain;
      }
      p {
        color: #050505;
        font-size: 0.32rem;
        line-height: 1;
      }
    }
    & > p {
      text-align: center;
      color: #fff;
      padding: 0.15rem 0;
      background: #ec4e4a;
      border-bottom-left-radius: 0.32rem;
      border-bottom-right-radius: 0.32rem;
      line-height: 1;
    }
    &--active {
      background: #fff;
    }
  }
}
</style>
